export default __webpack_public_path__ + "static/media/LEGO City .19e04c6e.jpg";